import { ChevronDownIcon } from '@chakra-ui/icons';
import React from 'react';
import { Flex } from '../Flex';
import { Menu } from '../Menu/Menu';
import { MenuButton } from '../Menu/MenuButton';
import { MenuItem } from '../Menu/MenuItem';
import { MenuList } from '../Menu/MenuList';
import { Text } from '../Text';
import { Box } from '../Box';

type ItemPropsValue = string | number | boolean | null;

interface CustomMenuItemProps {
  onClick?(value: ItemPropsValue): void;

  value: ItemPropsValue;
  label: string | number;
  isDisabled?: boolean;
  title?: string;
  'data-value'?: string;
}

export const CustomMenuItem = (props: CustomMenuItemProps) => {
  return (
    <MenuItem
      onClick={() => props.onClick && props.onClick(props.value)}
      fontSize={'14px'}
      fontFamily={'Ambit-Regular, Inter, sans-serif'}
      isDisabled={props.isDisabled}
      title={props.title}
      _hover={{
        background: 'gray.lightest',
      }}
      whiteSpace={'break-spaces'}
      data-value={props['data-value'] || ''}
    >
      {props.label}
    </MenuItem>
  );
};

interface CustomSelectProps {
  placeholder: string;
  children: React.ReactNode[] | React.ReactNode;
  value: string | number | boolean;
  displayValue?: string | number;
  isDisabled?: boolean;
  error?: boolean;
  onBlur?(event: React.FocusEvent<HTMLElement>): void;
  onOpen?(): void;
  onClose?(): void;
  'data-cy'?: string;
  'data-testid'?: string;
}

export function CustomSelect(props: CustomSelectProps) {
  return (
    <Menu matchWidth gutter={2} isLazy onOpen={props.onOpen} onClose={props.onClose}>
      <Box position={'relative'}>
        <MenuButton
          width={'100%'}
          border={'1px solid'}
          padding={'8px 7px'}
          h={'40px'}
          borderRadius={'10px'}
          disabled={props.isDisabled}
          bg={'#fff'}
          _focus={{
            borderColor: '#3182CE',
          }}
          borderColor={props.error ? 'error.main' : '#CBBFE6'}
          borderWidth={props.error ? '2px' : ''}
          type={'button'}
          onBlur={props.onBlur}
          _disabled={{
            opacity: '0.4',
            cursor: 'not-allowed',
          }}
          data-cy={props['data-cy'] || ''}
          data-testid={props['data-testid'] || ''}
        >
          <Flex display={'flex'} justifyContent={'space-between'} alignItems={'center'} padding={'0 8px'}>
            {!props.value && props.placeholder ? (
              <Text fontSize={'14px'} isTruncated opacity={0.5}>
                {props.placeholder}
              </Text>
            ) : (
              <Text fontSize={'14px'} isTruncated>
                {props.displayValue !== undefined ? props.displayValue : props.value}
              </Text>
            )}
            <ChevronDownIcon />
          </Flex>
        </MenuButton>
        <MenuList
          border={'1px'}
          borderColor={'#CBBFE6'}
          borderRadius={'10px'}
          maxHeight={'200px'}
          overflow={'auto'}
          position={'absolute'}
          left={0}
          top={0}
          maxW={'100%'}
          w={'100%'}
        >
          {props.children}
        </MenuList>
      </Box>
    </Menu>
  );
}
